import { isEqual } from 'lodash'
import { checkCache } from './helpers'

const handleUpdateEntry = (state, action) => {
  const { key, order, visible } = action

  // Update cache based on values
  checkCache(key, order, visible)

  const newState = {
    ...state,
    [key]: {
      order,
      visible
    }
  }

  if (!(key in state)) {
    return newState
  }

  // Prevent update if stored data is same as incoming
  const { order: oldOrder, visible: oldVisible } = state[key]
  if (isEqual(oldOrder, order) && isEqual(oldVisible, visible)) {
    return state
  }

  return newState
}

export const initialState = {}

export const Actions = {
  UPDATE_ENTRY: 'UPDATE_ENTRY'
}

const Handlers = {
  [Actions.UPDATE_ENTRY]: handleUpdateEntry
}

export const TaskPageStateReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown TaskPageState reducer type: ${type}`)
}
